import { useLocation, useHistory } from 'react-router-dom'
import qs from 'query-string'
import { useCallback } from 'react'

export const useQueryState = (query, defaultValue) => {
  const location = useLocation()
  const history = useHistory()

  const setQuery = useCallback(
    (value) => {
      const existingQueries = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      })

      const queryString = qs.stringify(
        { ...existingQueries, [query]: value },
        { skipNulls: true }
      )

      history.push(`${location.pathname}?${queryString}`)
    },
    [history, location, query]
  )

  return [
    qs.parse(location.search, { ignoreQueryPrefix: true })[query] ||
      defaultValue,
    setQuery,
  ]
}
